module.exports = __webpack_public_path__ + "img/pc_bg.73ad5bfb.jpg";